export default "__VITE_ASSET__CaNRMqbg__"